import React, { Fragment } from 'react'
import { Routes, Route, Navigate } from 'react-router-dom'

import PageHead, { PageHeading } from 'Layout/PageHead'
import PageContent from 'Layout/PageContent'
import PageLoader from 'Layout/PageLoader'
import PageTabs, { PageTabList, PageTab } from 'Layout/PageTabs'

import Appearance from './Appearance'
import Installation from './Installation'
import Transcripts from './Transcripts'
import Timezone from './Timezone'

import { useGetAllBotProfilesQuery } from 'Services/bot-profiles'
import SettingsTabPanel from './SettingsTabPanel'

const Settings = () => {
  const { isLoading: isFetchingBotProfiles, data: botProfiles } = useGetAllBotProfilesQuery()

  if (isFetchingBotProfiles) {
    return <PageLoader />
  }

  const botId = botProfiles.at(-1).id

  return (
    <Fragment>
      <PageHead>
        <PageHeading>Settings</PageHeading>
      </PageHead>

      <PageContent>
        <PageTabs>
          <PageTabList>
            <PageTab to='appearance' title='Appearance' />
            <PageTab to='installation' title='Installation' />
            <PageTab to='transcripts' title='Transcripts' />
            <PageTab to='timezone' title='Timezone' />
          </PageTabList>

          <Routes>
            <Route path='appearance' element={<SettingsTabPanel hideBg botId={botId} />}>
              <Route index element={<Appearance />} />
            </Route>
            <Route path='installation' element={<SettingsTabPanel botId={botId} />}>
              <Route index element={<Installation />} />
            </Route>
            <Route path='transcripts' element={<SettingsTabPanel botId={botId} />}>
              <Route index element={<Transcripts />} />
            </Route>
            <Route path='timezone' element={<SettingsTabPanel botId={botId} />}>
              <Route index element={<Timezone botId={botId} />} />
            </Route>
            <Route path='*' element={<Navigate to='appearance' replace />} />
          </Routes>
        </PageTabs>
      </PageContent>
    </Fragment>
  )
}

export default Settings
